import { ButtonLink } from '@branch-messenger/willow-ui'
import { createLink, LinkComponentProps } from '@tanstack/react-router'

const CreatedLink = createLink(ButtonLink)

export const TanstackButtonLink = ({
  ref,
  ...props
}: LinkComponentProps<typeof ButtonLink>) => {
  return <CreatedLink ref={ref} preload="intent" {...props} />
}

TanstackButtonLink.displayName = 'TanstackButtonLink'
